// extracted by css-extract-rspack-plugin
export default {"labelTokenBase":"LabelToken-module__labelTokenBase__Ao9u2","labelTokenDeleteButton":"LabelToken-module__labelTokenDeleteButton__S5Ly9"};